import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('shaver', true, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7847 18.73C21.0653 18.4493 21.5204 18.4493 21.8011 18.73L29.2699 26.1988C29.5506 26.4795 29.5506 26.9346 29.2699 27.2153L17.7574 38.7279C15.4142 41.071 11.6152 41.071 9.27208 38.7279C6.92893 36.3848 6.92893 32.5858 9.27208 30.2426L20.7847 18.73Z",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5813 22.3892C42.9303 22.0402 42.9303 21.4744 42.5813 21.1254L26.8745 5.41864C26.5255 5.06967 25.9597 5.06967 25.6108 5.41864L24.8284 6.20098C20.1421 10.8873 20.1421 18.4852 24.8284 23.1715V23.1715C29.5147 27.8578 37.1127 27.8578 41.799 23.1715L42.5813 22.3892Z",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8787 28.1212L18.4645 29.5354",
    stroke: props.colors[2],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6569 17.5146L30.4853 20.3431",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});